// 请在此处修改服务器重定向地址
const baseUrl = process.env.NODE_ENV == "production" ? "http://127.0.0.1:8013" : "http://127.0.0.1:8050" //"https://service.ecosystemtest.carrier.com"//"http://192.168.28.108:8050"

// AWS云：                       "http://18.138.15.157:8012"
// Liang Di个人电脑：            "http://192.168.28.42:8050"
// 本人个人电脑：                "http://127.0.0.1:8050"

exports.serviceConfig = {
  name: "iECM",
  mode: process.env.NODE_ENV,
  baseUrl,
  root: process.env.NODE_ENV == "production" ? baseUrl : "/api",
  enableSalesforceIntegration: false,
  enableQuickMode: false,
  environment: "", // UAT / TEST / 其他环境为空字符串

  // 测试环境配置信息，只支持一般登录方式
  // isProduction: false,
  // version: "V2.1.3.1" // 测试环境版本号

  // 正式环境配置信息，只支持Azure AD单点登录
  isProduction: true,
  version: "V2.2.3" // 正式环境版本号
}



// WEBPACK FOOTER //
// ./src/config/index.js